import { ArrowCounterClockwise, ArrowClockwise } from "@phosphor-icons/react";

export default function CorrectionNote({ item, kind, index, onToggle }) {
  const isAis = kind === "ais";
  const from = isAis ? item.ais_corrected_from : item.corrected_from;
  if (!from) return null;
  const overridden = isAis ? item.ais_overridden : item.overridden;
  const auditorCode = isAis ? item.ais_auditor?.ais2015_code : item.auditor?.code;

  return (
    <div
      className={`text-[11px] rounded px-2 py-1.5 mt-1 leading-snug border ${
        overridden ? "text-[#8C3A27] bg-[#F9EDE6] border-[#8C3A27]/25" : "text-[#4A5D4E] bg-[#E8EFEA] border-[#4A5D4E]/25"
      }`}
      data-testid={`correction-note-${kind}-${index}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          {overridden ? (
            <>
              <span className="font-semibold" data-testid={`overridden-tag-${kind}-${index}`}>Overridden by coder</span>
              <span> · auditor suggested </span>
              <span className="font-mono line-through">{auditorCode}</span>
            </>
          ) : (
            <>
              <span className="font-semibold">Corrected from </span>
              <span className="font-mono line-through">{from}</span>
            </>
          )}
          {item.correction_reason && <span> · {item.correction_reason}</span>}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggle?.();
          }}
          className="shrink-0 flex items-center gap-1 font-semibold border border-current/30 rounded px-1.5 py-0.5 hover:bg-white/70 transition-colors"
          title={overridden ? "Re-apply auditor's code" : "Revert to original draft code"}
          data-testid={`override-toggle-${kind}-${index}`}
        >
          {overridden ? <ArrowClockwise size={11} /> : <ArrowCounterClockwise size={11} />}
          {overridden ? "Re-apply" : "Revert"}
        </button>
      </div>
    </div>
  );
}
